export default "__VITE_ASSET__8c972b8e__"